import React from "react";

interface AuthDividerProps {
  text?: string;
}

export function AuthDivider({ text = "ou" }: AuthDividerProps) {
  return (
    <div className="relative flex items-center py-2">
      <div className="flex-grow border-t border-gray-200" />
      <span className="flex-shrink-0 px-4 text-sm text-gray-400">{text}</span>
      <div className="flex-grow border-t border-gray-200" />
    </div>
  );
}
